import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import PopularComics from './components/PopularComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import PlatformIntro from './components/PlatformIntro';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫网站',
  url: 'http://zbpost.cn/',
  description: '韩漫在线观看，免费漫画下拉式阅读平台。智能预加载技术确保各种网络环境下流畅浏览，看韩漫就上韩漫网站。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://zbpost.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫在线观看 - 免费漫画下拉式 - 漫画韩漫网址"
        description="韩漫在线观看，免费漫画下拉式阅读平台。通过专属网址享受极速在线观看体验，智能预加载技术确保各种网络环境下流畅浏览。涵盖恋爱、奇幻、动作、悬疑等全类型韩漫，看韩漫就上韩漫网站。"
        keywords="韩漫在线观看, 免费漫画下拉式, 漫画韩漫网址, 韩漫网站, 韩国漫画, 在线漫画阅读"
        canonicalUrl="/"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection />
        <PopularComics />
        <CategorySection />
        <LatestUpdates />
        <PlatformIntro />
        <Testimonial />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}